import React from 'react';

import './Layout.scss';
import { Header, Footer } from '../index';
import FloatingButton from '../FloatingButton';

function Layout ({ children }) {
  return (
    <div className='layout'>
      <Header />
      <div className='content'>{children}</div>
      <Footer />
      <FloatingButton />
    </div>
  );
};

export default Layout;
